import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let socket = null;
let heartbeatInterval = null;

function connectToSocket() {
  if (socket) {
    return socket;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    return {
      on: () => {},
      off: () => {},
      emit: () => {},
      connect: () => {},
      disconnect: () => {},
    };
  }

  let parsedToken;
  try {
    parsedToken = JSON.parse(token);
  } catch (err) {
    parsedToken = token;
  }

  socket = openSocket(getBackendUrl(), {
    transports: ["websocket", "polling"],
    query: {
      token: parsedToken,
    },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
  });

  const startHeartbeat = () => {
    if (heartbeatInterval) return;
    heartbeatInterval = setInterval(() => {
      if (socket && socket.connected) {
        socket.emit("heartbeat");
      }
    }, 30000);
  };

  const stopHeartbeat = () => {
    if (heartbeatInterval) {
      clearInterval(heartbeatInterval);
      heartbeatInterval = null;
    }
  };

  socket.on("connect", () => {
    console.log("[Socket] Connected");
    startHeartbeat();
  });

  socket.on("connect_error", (err) => {
    console.error("[Socket] Connect error:", err.message);
    if (
      err.message === "jwt expired" ||
      err.message === "invalid token" ||
      err.message === "Authentication error"
    ) {
      localStorage.removeItem("token");
      window.location.reload();
    }
  });

  socket.on("disconnect", (reason) => {
    console.log("[Socket] Disconnected:", reason);
    stopHeartbeat();
    if (reason === "io server disconnect") {
      socket.connect();
    }
  });

  socket.on("reconnect_attempt", (attemptNumber) => {
    console.log(`[Socket] Reconnecting... attempt ${attemptNumber}`);
  });

  socket.on("reconnect_failed", () => {
    console.error("[Socket] Reconnection failed, will keep retrying silently");
  });

  return socket;
}

export default connectToSocket;
